import React from "react";
import Layout from "@components/Layout";
import { useContentful } from "@hooks/use-contenful";
import { useGlsl } from "@hooks/use-glsl";
import { useData } from "@hooks/use-data";
//import { isMobile } from "react-device-detect";
import SEO from "@components/seo";
import { sgenitiv } from "@js/utils";

export default function Index(props) {
  const currentyear = 2021;
  const { country, name, lang } = props.pageContext;
  const data = useData(country, name, currentyear);
  const content = useContentful(name);
  const glsl = useGlsl();

  return (
    <>
      <SEO
        title={name}
        description={`Utforska ${sgenitiv(
          name
        )} koldioxidbudget. Var kommer utsläppen ifrån och hur mycket mer kan ${name} släppa ut enligt Parisavtalet?`}
        lang={lang}
      />
      {data.isLoading ? null : (
        <Layout
          data={data.data}
          content={content}
          glsl={glsl}
          currentyear={currentyear}
        />
      )}
    </>
  );
}
